import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { IConfigBoleto, TOpenModalBoleto, TPadraoLojas } from ".";
import { useMemo, useState, useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import SelectIntegracaoBancaria from "../../../../../components/SelectsSimpleApiQuery/SelectIntegracaoBancaria";
import { TConfiguracaoBancaria } from "../../../../../types/api/financeiro/configuracoes-bancarias";
import { TLoja } from "../../MIPedidos/DialogCriarPedidoVenda";
import SelectLojaComPesquisa from "../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";

export default function DialogEditAddIntegracaoLoja({
  open,
  defaultValue,
  configBoleto,
  handleClose,
  onSuccess
}: IDialogEditAddIntegracaoLojaProps) {

  const [configPadrao, setConfigPadrao] = useState<TConfiguracaoBancaria | null>(null);
  const [integracao, setIntegracao] = useState<TConfiguracaoBancaria | null>(null);
  const [loja, setLoja] = useState<TLoja | null>(null);

  const isEdit = useMemo(() => Boolean(defaultValue?.defaultValue), [defaultValue])
  const valoresIniciais = useMemo(() => defaultValue?.defaultValue || null, [defaultValue])

  useEffect(() => {
    if (valoresIniciais) {
      setLoja({
        id: valoresIniciais.loja_id,
        nome: valoresIniciais.loja_nome
      } as TLoja);

      setIntegracao({
        id: valoresIniciais.integracao.id,
        nome_banco: valoresIniciais.integracao.nome_banco
      } as TConfiguracaoBancaria);
    } else {
      setLoja(null);
      setIntegracao(null);
    }
  }, [valoresIniciais]);

  const { mutate: atualizarConfig, isLoading } = useMutation({
    mutationKey: 'atualizar-config-comercial-conta-transitoria',
    mutationFn: (inputs: TAtualizarConfiguracoesComercialBoleto) => axiosClient.post(`atualizar-configuracoes`, inputs),
    onError: (error) => {
      console.error(error)
      enqueueSnackbar('Erro ao salvar configuração!', { variant: 'error' });
    },
    onSuccess: () => {
      enqueueSnackbar(isEdit ? 'Configuração atualizada com sucesso!' : 'Configuração adicionada com sucesso!', { variant: 'success' });
      handleClose();
      onSuccess?.();
    }
  })

  const handleSubmit = () => {
    if (!loja || !integracao) {
      enqueueSnackbar('Por favor, preencha todos os campos obrigatórios!', { variant: 'warning' });
      return;
    }

    if (!configBoleto) {
      enqueueSnackbar('Erro: configuração de boleto não encontrada!', { variant: 'error' });
      return;
    }

    const novaConfiguracao: TPadraoLojas = {
      loja_id: loja.id,
      loja_nome: loja.nome,
      integracao: {
        id: integracao.id,
        nome_banco: integracao.nome_banco
      }
    };

    let novasPadraoLojas: TPadraoLojas[];

    if (isEdit && valoresIniciais) {
      novasPadraoLojas = configBoleto.padrao_lojas.map(item =>
        item.loja_id === valoresIniciais.loja_id ? novaConfiguracao : item
      );
    } else {
      novasPadraoLojas = [novaConfiguracao];
    }

    atualizarConfig({
      chave: "comercial_boletos",
      valor: {
        padrao_boleto: configPadrao ? {
          id: configPadrao.id,
          nome_banco: configPadrao.nome_banco,
        } : {id: 1, nome_banco: 'Sicoob'},
        padrao_lojas: novasPadraoLojas
      }
    });
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{isEdit ? 'Editar' : 'Adicionar'} Integração de Loja</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={1}>
          <Grid size={{xs: 12}}>
            <SelectIntegracaoBancaria
              label="Configuração Padrão"
              value={configPadrao || (configBoleto?.padrao_boleto ? {
                id: configBoleto.padrao_boleto.id,
                nome_banco: configBoleto.padrao_boleto.nome_banco,
                codigo: '',
                agencia: 0,
                agencia_digito: 0,
                conta: 0,
                conta_digito: 0
              } as TConfiguracaoBancaria : null)}
              onChange={(value) => {
                setConfigPadrao(value);
              }}
            />
          </Grid>
          <Grid size={{xs:12, md: 6}}>
            <SelectIntegracaoBancaria
              value={integracao}
              onChange={(value) => {
                setIntegracao(value);
              }}
            />
          </Grid>
          <Grid size={{xs:12, md: 6}}>
            <SelectLojaComPesquisa
              value={loja}
              onChange={(value) => {
                setLoja(value as TLoja);
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isLoading}
        >
          {isEdit ? 'Salvar' : 'Adicionar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

interface IDialogEditAddIntegracaoLojaProps {
  open: boolean;
  handleClose: () => void;
  defaultValue?: TOpenModalBoleto | null;
  configBoleto: IConfigBoleto | null;
  onSuccess?: () => void;
}

export type TAtualizarConfiguracoesComercialBoleto = {
  chave: string;
  valor: IConfigBoleto;
}